import { render, staticRenderFns } from "./FieldMain.vue?vue&type=template&id=f641cf78&scoped=true"
import script from "./FieldMain.vue?vue&type=script&lang=js"
export * from "./FieldMain.vue?vue&type=script&lang=js"
import style0 from "./FieldMain.vue?vue&type=style&index=0&id=f641cf78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f641cf78",
  null
  
)

export default component.exports